export default {
  logins:{
    scanLogin:"扫码登录",
    passwordLogin:"密码登录",
    login:"登录",
    phoneNull:"请填写手机号",
    phoneCheck:"请填写正确的手机号",
    passwordNull:"请填写密码",
    passwordCheck:"密码长度在6位以上",
    scan:"扫码",
    open:"打开",
    toLogin:"登录",
    wechat:"微信",
    loginAfter:"正在加载",
    loginRefresh:"重新登录",
    noOperate:"没有操作数据！",
    loginSuccess:"欢迎"
  },
  app: {
    search: "搜索菜单",
    home: "首页",
    help: "帮助中心",
    language: "语言",
    english: "英文",
    chinese: "中文",
    message: "我的消息",
    languageTtile: "语言切换会刷新页面确定吗？",
    logoutTitle:"提示",
    logoutContent:"你确认退出吗?",
    personalCenter:'个人中心',
    switchRoles:'切换角色',
    setting:'设置',
    quit:'退出',
  },
  personal:{
    currentIdentity:"当前身份",
    accountType:"账户类型",
    modifyAvatar:"修改头像",

    finish:"已完成",
    setting:"未设置",
    accountPassword:'帐号密码',
    accountPasswordDec:'为了保护帐号安全，登录时使用',
    accountInfo:'帐号资料',
    accountInfoDec:'帐号归属者的基本资料',
    realName:'实名认证',
    realNameDec:'用于识别帐号所有权的归属者，以提高安全性',
    contactMobile:'联系手机（如已经换号，请及时修改）',
    contactMobileDec:'用于找回密码、安全验证',
    contactMailbox:'联系邮箱',
    contactMailboxDec:'用于找回密码、安全验证',
    bindingWeChat:'绑定微信',
    bindingWeChatDec:'可提供技术支持、业务办理进度通知',
  },
  button: {
    search: "搜索",
    refresh: "刷新",
    create: "创建",
    edit: "明细",
    write: "编辑",
    import: "导入",
    export: "导出",
    invalid: "失效",
    selectTemp: "选择模板",
    downloadTemp: "下载模板",
    submit: "提交",
    return: "返回",
    cancel: "取消",
    confirm: "确认",
    select: "选择",
    back: "退回",
    close: "关闭",
    open: "打开",
    modify: "修改",
    setting: "设置",
    finish:"完成"
  },
  form:{
    status:"状态",
    select:'选择',
    englishName:'英文名',
    createUser:'创建人',
    createTime:'创建时间',
  },
  placeholder:{
    input:'请填写{name}',
    select:'请选择{name}',
  },
  dialog:{
    cancel:'取 消',
    confirm: "确 定",
  },
  route: {
    home:"首页",
    system:"系统",
    role:"角色",
    attach:"附件",
    operate:"操作日志",
    log:"日志",
    enum:"枚举",
    power:"权限",
    module:"模块",
    user:"用户",
    login:"登录日志",
    rootNode:"根节点",
  },
  rules:{
    required:'此字段必填',
  },
  tooltip:{
    toolbarEdit:'请选择一条记录'
  },
  module:{
    moduleName:"模块名称",
    languageKey:"语言代码",
    modulePath:"模块路径",
    moduleIcon:"图标",
    moduleNode:"模块节点",
    moduleStatus:"模块状态",
    pinYin:'拼音',
    moduleStatusObj:{
      enable:'禁用',
      open:'开放',
      maintain:'维护',
    }
  }
 
}
